import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_scqtpm",
  "use": "icon-icon_scqtpm-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-icon_scqtpm\">\n<path fill-rule=\"evenodd\" fill=\"rgb(255, 255, 255)\" d=\"M20.000,9.000 L20.000,20.000 L5.000,20.000 L5.000,10.186 C4.900,10.646 4.463,11.000 3.913,11.000 C3.291,11.000 2.785,10.555 2.785,10.004 L2.785,3.451 L1.928,4.208 C1.487,4.598 0.773,4.597 0.332,4.208 C-0.108,3.819 -0.108,3.189 0.332,2.800 L3.202,0.267 C3.642,-0.122 4.357,-0.122 4.797,0.267 L7.666,2.800 C8.107,3.189 8.107,3.819 7.667,4.208 C7.446,4.403 7.158,4.500 6.869,4.500 C6.580,4.500 6.291,4.403 6.071,4.208 L5.042,3.299 L5.042,9.000 L20.000,9.000 ZM14.000,11.000 L11.000,11.000 L11.000,12.000 L14.000,12.000 L14.000,11.000 ZM7.000,18.000 L18.000,18.000 L18.000,17.000 L7.000,17.000 L7.000,18.000 ZM7.000,15.000 L18.000,15.000 L18.000,14.000 L7.000,14.000 L7.000,15.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon_scqtpm.svg
// module id = qdi6
// module chunks = 70